import { render } from "./ImportModalPriorityDestination.vue?vue&type=template&id=2a6679d0&scoped=true"
import script from "./ImportModalPriorityDestination.vue?vue&type=script&lang=js"
export * from "./ImportModalPriorityDestination.vue?vue&type=script&lang=js"

import "./ImportModalPriorityDestination.vue?vue&type=style&index=0&id=2a6679d0&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6679d0"]])

export default __exports__